export default function materials(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                material: action.material,
            }
        default:
            return state;
    }
}
